<template>
    <div class="container mt-1 mb-1">
        <div class="home-buttons mb-2 d-flex justify-content-center justify-content-md-start">
            <a class="btn-place-win-points bg-darkblue btn-insitu py-3 px-1" href="/retos">
                <img class="img-menu-fixed" src="/img/icons/star.svg" alt="Gana Puntos" />
                Gana Puntos
            </a>

            <a id="btn-canjea-home" title="Canjea" class="btn-redeem-home py-3 px-1" href="/catalogo">
                <img class="img-menu-fixed" src="/img/icons/canjea_blue_king.svg" alt="Canjea" />
                Canjea
            </a>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            //
        };
    },
    mounted() {
        //
    },
    methods: {
        //
    },
}
</script>

